import { render, staticRenderFns } from "./kjfwms.vue?vue&type=template&id=be91fdc4&scoped=true&"
import script from "./kjfwms.vue?vue&type=script&lang=js&"
export * from "./kjfwms.vue?vue&type=script&lang=js&"
import style0 from "./kjfwms.vue?vue&type=style&index=0&id=be91fdc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be91fdc4",
  null
  
)

export default component.exports